import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import useWebview from "@hooks/useWebview";
import { useTranslation } from "@i18n";
import { useState } from "react";
import useIsMobile from "@hooks/useIsMobile";
import useHandleBackButton from "@hooks/useHandleBackButton";
import FilePreview from "@/pages/tracking/components/SharedComponents/StepDetailsComponent_TS/StepBody/ViewOfferedDocuments/FilePreview/FilePreview";
import useIsWebView from "@hooks/useIsWebview";
var isFileTypePDF = function isFileTypePDF(domInMemoryFile, filePath) {
  var _domInMemoryFile$name;
  return (domInMemoryFile === null || domInMemoryFile === void 0 ? void 0 : (_domInMemoryFile$name = domInMemoryFile.name) === null || _domInMemoryFile$name === void 0 ? void 0 : _domInMemoryFile$name.indexOf(".pdf")) > -1 || (filePath === null || filePath === void 0 ? void 0 : filePath.indexOf(".pdf")) > -1;
};
function getBase64FromFile(_x) {
  return _getBase64FromFile.apply(this, arguments);
}
function _getBase64FromFile() {
  _getBase64FromFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, new Promise(function (resolve, reject) {
            var reader = new FileReader();

            // Event handler for successful read
            reader.onload = function () {
              var base64String = reader.result.split(',')[1]; // Remove the data URL prefix
              resolve(base64String);
            };

            // Event handler for errors
            reader.onerror = function (error) {
              reject(error);
            };

            // Read the file as a Data URL
            reader.readAsDataURL(file);
          }));
      }
    }, _callee2);
  }));
  return _getBase64FromFile.apply(this, arguments);
}
var LinkToFile = function LinkToFile(_ref) {
  var setShowDeletePopup = _ref.setShowDeletePopup,
    originalInputRef = _ref.originalInputRef,
    dbFile = _ref.dbFile,
    stepStatus = _ref.stepStatus,
    _ref$g4_data = _ref.g4_data,
    g4_data = _ref$g4_data === void 0 ? {} : _ref$g4_data,
    domInMemoryFile = _ref.domInMemoryFile,
    fileUri = _ref.fileUri,
    renderFunc = _ref.renderFunc;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var webview = useWebview();
  var isWebView = useIsWebView();
  var isMobile = useIsMobile();
  var _useState = useState(false),
    showFilePrev = _useState[0],
    setShowFilePrev = _useState[1];
  useHandleBackButton(function () {
    setShowFilePrev(false);
  });
  var isPdf = isFileTypePDF(domInMemoryFile, fileUri);
  var isImage = !isPdf;
  var canPreview = function canPreview() {
    if (isWebView) {
      return true;
    }
    if (isPdf) {
      if (domInMemoryFile) {
        return true;
      }
    }
    return isImage;
  };
  var getLabel = function getLabel() {
    if (!canPreview()) {
      return t("download_document_2", {
        ns: "web_tracking"
      });
    }
    if (isPdf) {
      return t("show_file", {
        ns: "web_tracking"
      });
    }
    return t("show_image", {
      ns: "web_tracking"
    });
  };
  var downloadFileOrShowPreview = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var fallback, b64Data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (canPreview()) {
              _context.n = 1;
              break;
            }
            document.location = "/download?url=".concat(encodeURIComponent(fileUri));
            return _context.a(2);
          case 1:
            fallback = function fallback() {
              setShowFilePrev(true);
              window.history.pushState({}, "", window.location.pathname + "#preview");
            };
            if (!isPdf) {
              _context.n = 5;
              break;
            }
            if (!fileUri) {
              _context.n = 2;
              break;
            }
            webview.openFile(fileUri)["catch"](function (error) {
              fallback();
            });
            _context.n = 4;
            break;
          case 2:
            _context.n = 3;
            return getBase64FromFile(domInMemoryFile);
          case 3:
            b64Data = _context.v;
            webview.openBase64File(b64Data, domInMemoryFile.name, "application/pdf")["catch"](function (error) {
              fallback();
            });
          case 4:
            if (isMobile) {} else {
              setShowFilePrev(true);
            }
            _context.n = 6;
            break;
          case 5:
            fallback();
          case 6:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function downloadFileOrShowPreview() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleClose = function handleClose() {
    setShowFilePrev(false);
    if (window.location.hash === '#preview') {
      window.history.replaceState({}, '', window.location.pathname);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showFilePrev && /*#__PURE__*/React.createElement(FilePreview, {
    orginalInput: originalInputRef,
    domInMemoryFile: domInMemoryFile,
    dbFile: dbFile,
    onClose: handleClose,
    setShowDeletePopup: setShowDeletePopup,
    stepStatus: stepStatus,
    g4_data: g4_data,
    hideButtons: !fileUri || (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) !== "rejected"
  }), renderFunc(getLabel(), downloadFileOrShowPreview));
};
export default LinkToFile;